import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const valuePropsCard = (theme: Theme) => css`
  background-color: ${theme.success.backgroundMuted};
  border-radius: 0.5rem;
  padding: 1rem;
`;

export const valuePropTitle = css`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  align-items: center;
`;

export const valuePropsList = css`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 0.5rem;
`;

export const valuePropItem = css`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

export const logo = css`
  width: 1rem;
  height: 100%;
  object-fit: contain;
  margin: auto 0;
`;
